import React, { useState, useEffect, Suspense } from 'react'
import axios from 'axios'
import LoadingBar from 'react-top-loading-bar'
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import InfiniteScroll from "react-infinite-scroller";
import {Helmet} from "react-helmet";
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { ReactSession } from 'react-client-session';

import Header from '../Header/Header'
import Sidebar from '../Sidebar/Sidebar'
import Footer from '../Footer/Footer'

import './Weblinks.css'
import styles from '../../App.module.css'
import classes from './WebLinks.module.css'
import SingleWeblink from '../Global/SingleWeblink'
import Spinner from '../Global/Spinner'
import LoadMoreButton from '../Global/LoadMoreButton'
import EmptyContent from '../Global/EmptyContent'

function WebLinks() {
  const [progress, setProgress] = useState(0);
  const [weblinks, setWeblinks] = useState([]);
  const [hasMore, sethasMore] = useState(false);
  const [page, setPage] = useState(2);
  const [loading, setLoading] = useState(false);
  const [tabIndex, setTabIndex] = useState(0);
  const [type, setType] = useState('mostviewed');

  ReactSession.setStoreType("localStorage");
  const logged_user = ReactSession.get("logged_user");

  useEffect(() => {
    try{
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    }catch(ex){}
  }, []);

  useEffect(() => {
    if(tabIndex === 0) {
      setType('mostviewed');
      // setType('');
    }else if(tabIndex === 1) {
        setType('latest');
    }else if(tabIndex === 2) {
      setType('mostliked');
    }

    setPage(2);
    setWeblinks([]);
    sethasMore(false);
  }, [tabIndex]);

  useEffect(() => {
    setLoading(true);
    setProgress(20);

    axios.get(`${process.env.REACT_APP_API_URL}/api/weblinks.php?type=${type}&user_id=${logged_user}&limit=12`)
    .then(res => {
      // console.log(res.data);
      setWeblinks(res.data);
      res.data.length < 12 ? sethasMore(false) : sethasMore(true);
      
      setLoading(false);
      setProgress(100);
    })
  }, [type]);

  const loadMore = () => {
    setLoading(true);
    axios.get(`${process.env.REACT_APP_API_URL}/api/weblinks.php?type=${type}&user_id=${logged_user}&limit=12&page=${page}`)
    .then(res => {
      if(res.data.message !== 'No weblinks found') {
        setWeblinks([...weblinks, ...res.data]);
        setPage(page + 1);

        res.data.length < 12 ? sethasMore(false) : sethasMore(true);
      }else {
        sethasMore(false);
      }
      setLoading(false);
    }).catch(err => {
      console.log(err);
    })
  }

  return (
    <>
      <Helmet>
          <title>Web Pages</title>
          <meta name="description" content="Share your web pages, articles, blog entries, photographs, and videos with friends, family, and the world on Wesharez." />
          <meta name="keywords" content="wesharez, youtube videos, musics, images, albums, earn money, Bookmarking, be a creator, share video, share your content, products, services, products and services, blog, latest articles, web pages, views, skin, science, days, review" />
      </Helmet>
      <LoadingBar
        color='#f11946'
        progress={progress}
        onLoaderFinished={() => setProgress(0)}
      />
      <Header />
      <ToastContainer />
      <div className={styles.main_body}>
        <Suspense fallback="<div>Please wait...</div>">
          <Sidebar active="weblinks" />
        </Suspense>
        <Suspense fallback="<div>Please wait...</div>">
          <div className={styles.main_content + ` main-content`}>
            <ins className='adsbygoogle p-4 pb-0'
                style={{ display: 'block' }}
                data-ad-client='ca-pub-8126596259429304'
                data-ad-slot='5153011292'
                data-ad-format='auto'
            />
            <div className="weblinks-component p-4">
              <div className={classes.sec_heading}>
                <h2 className='m-0'>Web Pages</h2>
              </div>
              <Tabs className="mb-4" selectedIndex={tabIndex} onSelect={(index) => setTabIndex(index) }>
                <TabList>
                    <Tab>Most views</Tab>
                    <Tab>Latest</Tab>
                    <Tab>Most likes</Tab>
                </TabList>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
                <TabPanel></TabPanel>
              </Tabs>
              {
                weblinks && weblinks.map ? <div className={styles.weblinks}>
                  {
                    weblinks.map((weblink, index) => {
                      return (
                        <div key={index}>
                          {
                            SingleWeblink(weblink)
                          }
                        </div>
                      )
                    })
                  }
                </div>
                : <EmptyContent />
              }
            </div>
            <div className={classes.wraper} align="center">
              {
                !loading && hasMore && <span onClick={loadMore}><LoadMoreButton text="Load more..." /></span>
              }
              {
                loading && <Spinner />
              }
            </div>
            <Footer />
          </div>
        </Suspense>
      </div>
      </>
  )
}

export default WebLinks